import { useTranslation } from 'react-i18next';
import InvoiceCreateForm from '../form/InvoiceCreateForm';
import { EnhancedDialog } from 'components/enhanced';

const TRANSLATION_PREFIX = 'pages.invoices.new';

interface CreateInvoiceDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: any) => void;
}

export const CreateInvoiceDialog = ({ isOpen, onClose, onSubmit }: CreateInvoiceDialogProps) => {
  const { t } = useTranslation();

  return (
    <EnhancedDialog
      open={isOpen}
      onClose={onClose}
      title={t(`${TRANSLATION_PREFIX}.title`)}
      subTitle={t(`${TRANSLATION_PREFIX}.subtitle`)}
      submitLabel={t('actions.save', 'Salva')}
      cancelLabel={t('actions.reset', 'Annulla')}
      maxWidth="md"
      submitButtonProps={{
        type: 'submit',
        form: 'newInvoice'
      }}>
      <InvoiceCreateForm onSubmit={onSubmit} />
    </EnhancedDialog>
  );
};

export default CreateInvoiceDialog;
